import type { TreeDataItem } from "@/components/tree-view";

export function findNameById(
  items: TreeDataItem[],
  id: string
): string | undefined {
  const stack = [...items];
  while (stack.length) {
    const node = stack.pop()!;
    if (node.id === id) return node.name;
    if (node.children) stack.push(...node.children);
  }
  return undefined;
}
